import { arrayMove } from '@dnd-kit/sortable';
import { GridRowOrderChangeParams } from '@mui/x-data-grid-pro';
import { Row } from '@tanstack/react-table';
import { rankItem } from '@tanstack/match-sorter-utils';

/**
 * Drag & drop row reordering of a DataGrid: a handle column to drag the rows by, and the moved row's old and new
 * index once it's dropped somewhere else. Turned off while the previous order is being saved. Rows can't be sorted
 * or paged meanwhile - the grid turns reordering off then.
 */
export const rowReorderingProps = (
  onReorder: (oldIndex: number, targetIndex: number) => void,
  disabled = false,
) => ({
  rowReordering: !disabled,
  onRowOrderChange: ({ oldIndex, targetIndex }: GridRowOrderChangeParams) => {
    if (oldIndex !== targetIndex) {
      onReorder(oldIndex, targetIndex);
    }
  },
});

/** The rows' new order numbers (from 1) after moving one from oldIndex to targetIndex - all saved together. */
export const reorderedPriorities = <T extends { id?: number }>(
  rows: T[],
  oldIndex: number,
  targetIndex: number,
) =>
  arrayMove(rows, oldIndex, targetIndex).map(({ id }, index) => ({
    // listed rows are saved ones, they always have an id
    id: id as number,
    prioritySn: index + 1,
  }));

export const fuzzyFilter = <DTO>(row: Row<DTO>, columnId, value, addMeta) => {
  const itemRank = rankItem(row.getValue(columnId), value);
  addMeta({ itemRank });
  return itemRank.passed;
};
